module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('app-header', {
    attrs: {
      "icon": "empty"
    }
  }, [_vm._v("\n        Restitution\n    ")]), _vm._v(" "), _c('action-bar', {
    attrs: {
      "back": {
        name: 'home'
      }
    }
  }, [_c('a', {
    staticClass: "btn add btn-full",
    class: {
      disabled: _vm.saving
    },
    attrs: {
      "id": "main-action"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.restitution($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-go"
  }), _vm._v(" "), _c('strong', [_vm._v("Rendre")]), _vm._v("ces bouteilles\n        ")])]), _vm._v(" "), _c('filter-bar', {
    attrs: {
      "placeholderFilter": "Rechercher par Numéro, Otag"
    },
    on: {
      "searchBarChanged": _vm.updateSearch
    }
  }), _vm._v(" "), (this.bouteilles.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "icon-gas",
    staticStyle: {
      "font-size": "5rem",
      "color": "#ccc"
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "#ccc",
      "margin-top": "0.5rem"
    }
  }, [_vm._v("Aucune bouteille à restituer")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#999",
      "margin-top": "0.5rem"
    }
  }, [_vm._v("Vous n'avez aucune bouteille à restituer pour le moment")]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list list-bout bouteilles restitution",
    attrs: {
      "id": "bouteilles-item"
    }
  }, _vm._l((_vm.filtredBottles()), function(bout) {
    return _c('div', {
      key: bout.id,
      staticClass: "check",
      attrs: {
        "data-fournisseur": bout.fournisseur
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'restit-' + bout.id,
        "name": 'restit-' + bout.id
      },
      domProps: {
        "value": bout.id,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, bout.id) > -1 : (_vm.selected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = bout.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "item labcheck wrap",
      class: _vm.classBouteille(bout.type),
      attrs: {
        "for": 'restit-' + bout.id
      }
    }, [_c('p', {
      staticClass: "identification"
    }, [_c('span', [_vm._v("\n          DISTRIBUTEUR\n          "), _c('strong', [_vm._v(_vm._s(bout.fournisseur.nom))])]), _vm._v(" "), _c('br'), _vm._v(" Bouteille\n                    "), (bout.nom) ? _c('strong', [_vm._v(_vm._s(bout.nom.nom))]) : _vm._e(), _vm._v(" "), (bout.marque) ? [_c('br'), _vm._v(" "), _c('span', [_vm._v("\n                            Marque\n                            "), _c('strong', {
      staticClass: "marque"
    }, [_vm._v(_vm._s(bout.marque))])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "floating"
    }, [_c('div', {
      staticClass: "id-bouteille"
    }, [_c('i', {
      staticClass: "icon-gas"
    }), _vm._v("\n                        " + _vm._s(bout.code) + "\n                    ")]), _vm._v(" "), (bout.fluide) ? _c('div', {
      staticClass: "refrigerant"
    }, [_c('i', {
      staticClass: "icon-fluid"
    }), _vm._v("\n                        " + _vm._s(bout.fluide.nom) + "\n                    ")]) : _vm._e(), _vm._v(" "), (bout.otag) ? _c('div', {
      staticClass: "otag"
    }, [_c('i', {
      staticClass: "icon-otag"
    }), _vm._v("\n                        " + _vm._s(bout.otag) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "icon-valid check"
    }), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }), _vm._v(" "), (bout.otag) ? _c('span', {
      staticClass: "level-bar"
    }, [_c('span', {
      staticClass: "full-level"
    }), _vm._v(" "), _c('span', {
      staticClass: "level",
      style: (_vm.getStyle(bout.poids_net, bout.poids_max))
    })]) : _vm._e()])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5719fa7f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/RestitutionBouteilles.vue
// module id = 764
// module chunks = 0